import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { Button } from "../../shadcn/button";

export function CopyJsonButton({ data }: { data: Record<string, unknown> }) {
  const [copied, setCopied] = useState(false);
  return (
    <Button
      variant="ghost"
      size="iconsm"
      aria-label="Copy JSON"
      data-testid="copy-json"
      data-copied={copied}
      className="px-2 text-muted-foreground hover:bg-transparent shrink-0"
      onClick={async () => {
        await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }}
    >
      {copied ? (
        <Check strokeWidth={1.3} size={16} />
      ) : (
        <Copy strokeWidth={1.3} size={16} />
      )}
    </Button>
  );
}
